import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const { focusedItemIndex, numColumns, searchFilter, showSelectAll } = this.state;
  const checkboxItems = this.helpers.getItemsToDisplay();
  const totalMatchingItems = this.helpers.getTotalMatchingItems();
  const displaySelectAll = showSelectAll && !searchFilter;
  const displaySelectAllMatching = this.attr(`show-csv-matches`) && searchFilter && totalMatchingItems;
  const allMatchingItemsSelected = this.helpers.allMatchingItemsSelected();
  const allSelected = displaySelectAllMatching ? allMatchingItemsSelected : this.helpers.allSelected();
  return /* @__PURE__ */ jsx("ul", { sel: ".mp-checkbox-list-list", hook: { postpatch: this.helpers.handlePostPatch } }, checkboxItems.length ? /* @__PURE__ */ jsx(null, null, displaySelectAll || displaySelectAllMatching ? /* @__PURE__ */ jsx(
    "li",
    {
      sel: ".mp-checkbox-list-checkbox-item.mp-checkbox-list-checkbox-select-all",
      class: {
        "mp-checkbox-list-two-columns": numColumns === 2,
        "mp-checkbox-list-three-columns": numColumns === 3,
        "mp-checkbox-list-four-columns": numColumns === 4
      },
      on: {
        click: displaySelectAllMatching ? this.helpers.toggleSelectAllMatching : this.helpers.toggleSelectAll
      }
    },
    /* @__PURE__ */ jsx(
      "div",
      {
        sel: ".mp-checkbox-list-checkbox-select-icon",
        class: { "mp-checkbox-list-checkbox-dash": !allSelected }
      },
      /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: allSelected ? `checkmark` : `dash` } })
    ),
    /* @__PURE__ */ jsx("div", { sel: ".mp-checkbox-list-checkbox-label" }, displaySelectAllMatching ? `Select all matching` : `Select all`)
  ) : null, checkboxItems.map((item) => {
    const isFocused = focusedItemIndex === item.index;
    const isSelected = item.isSelected;
    return /* @__PURE__ */ jsx(
      "li",
      {
        sel: ".mp-checkbox-list-checkbox-item",
        class: {
          "mp-checkbox-list-focused": isFocused,
          "mp-checkbox-list-two-columns": numColumns === 2,
          "mp-checkbox-list-three-columns": numColumns === 3,
          "mp-checkbox-list-four-columns": numColumns === 4
        },
        on: {
          click: () => this.helpers.handleClickItem(item),
          mouseenter: () => this.helpers.handleMouseenterItem(item)
        }
      },
      /* @__PURE__ */ jsx("div", { sel: ".mp-checkbox-list-checkbox-select-icon", class: { "mp-checkbox-list-colored": isSelected } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `checkmark`, empty: !isSelected } })),
      /* @__PURE__ */ jsx("div", { sel: ".mp-checkbox-list-checkbox-label" }, item.matches ? item.matches.map((substr, si) => /* @__PURE__ */ jsx("span", { sel: ".substr", class: { "matches-search": !(si % 2) } }, substr)) : /* @__PURE__ */ jsx("span", { sel: ".label" }, item.label))
    );
  })) : null);
}
